import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {
		height: '100%',
		position: 'relative',
	},
}));
